(function ($) {
  "use strict";

  /*** Home page Scripts***/

  /* Init TinySlider2 */
  if (typeof tns === 'function') {

    /* Wrap every two product items in parent div, if less then 769px. In order tow build two row slider */
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    if (mediaQuery.matches) {
      $(document).find('.productsSlide ul.products').each((index, el) => {
        $(el).each(function(){
          const divs =  $(this).find('li');

          for (let i = 0; i < divs.length; i+=2) {
            divs.slice(i, i+2).wrapAll("<div class='productsSlide_pairWrap'></div>");
          }

        });

      });
    }

    const $productRows = document.querySelectorAll('.js_slideProducts .products');

    $productRows.forEach((element, index) => {
      tns({
        container: element,
        items: 2,
        slideBy: 'page',
        loop: false,
        speed: 400,
        nav: false,
        responsive: {
          768: {
            items: 3
          },
          1200: {
            items: 4
          },
          1400: {
            items: 5
          },
        }
      });
    });


    $(document).on('click', '.js_sliderPrev', function(e) {
      e.preventDefault();

      const $parent = $(this).parents('.js_slideProducts');

      if ($parent.length) {
        const $prevControl = $parent.find('[data-controls="prev"]');

        if ($prevControl.length) {
          $prevControl.click();
        }
      }
    });

    $(document).on('click', '.js_sliderNext', function(e) {
      e.preventDefault();
      const $parent = $(this).parents('.js_slideProducts');

      if ($parent.length) {
        const $nextControl = $parent.find('[data-controls="next"]');
        if ($nextControl.length) {
          $nextControl.click();
        }
      }
    });

  }


})(jQuery);
